import { userApi } from '@api/queries';
import {
  type ClaimTaskRewardResponseType,
  type PartnerDto,
  type PartnerTaskDto,
} from '@common/types/query/tasks';
import { type UserTaskType } from '@common/types/user';
import { createSlice, isAnyOf, type PayloadAction } from '@reduxjs/toolkit';

interface UserTasksInitialStateType {
  list: UserTaskType[] | null;
  social: PartnerDto[] | null;
  partners: PartnerDto[] | null;
}

const initialState: UserTasksInitialStateType = {
  list: null,
  social: null,
  partners: null,
};

const tasksSlice = createSlice({
  name: 'userTasks',
  initialState,
  reducers: {
    counterPartnerTaskTimer: (state) => {
      // 1. Об'єднуємо партнерів з 'partners' та 'social' в один масив
      const allPartners = [...(state.partners || []), ...(state.social || [])];

      // 2. Витягуємо всі завдання з об'єднаного масиву партнерів
      const tasks = allPartners.flatMap((partner) => partner.partnerTask);

      for (const task of tasks) {
        if ((task.delayTimer || 0) > 0) {
          task.delayTimer -= 1;
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        userApi.endpoints.getUserTasks.matchFulfilled,
        (state, { payload }: PayloadAction<UserTaskType[]>) => {
          state.list = payload;
        },
      )
      .addMatcher(
        userApi.endpoints.claimTaskById.matchFulfilled,
        (state, { payload }: PayloadAction<ClaimTaskRewardResponseType>) => {
          state.list = payload.tasks;
        },
      )
      .addMatcher(
        userApi.endpoints.getPartnersTask.matchFulfilled,
        (state, { payload }: PayloadAction<PartnerDto[]>) => {
          const starIndustryPartner = payload.find(
            (partner) => partner.name === 'StarIndustry',
          );

          const otherPartners = payload.filter(
            (partner) => partner.name !== 'StarIndustry',
          );

          state.social = starIndustryPartner ? [starIndustryPartner] : [];
          state.partners = otherPartners;
        },
      )
      .addMatcher(
        isAnyOf(
          userApi.endpoints.completePartnerTask.matchFulfilled,
          userApi.endpoints.getPartnerTaskReward.matchFulfilled,
        ),
        (state, { payload }: PayloadAction<PartnerTaskDto>) => {
          if (!state.social || !state.partners) return;

          const partnerInPartnersIndex = state.partners.findIndex(
            (p) => p.id === payload.partnerId,
          );

          if (partnerInPartnersIndex !== -1) {
            const partner = state.partners[partnerInPartnersIndex];
            const taskIndex = partner.partnerTask.findIndex(
              (t) => t.id === payload.id,
            );

            if (taskIndex !== -1) {
              partner.partnerTask[taskIndex] = payload;
            }

            return;
          }

          const partnerInSocialIndex = state.social.findIndex(
            (p) => p.id === payload.partnerId,
          );

          if (partnerInSocialIndex !== -1) {
            const partner = state.social[partnerInSocialIndex];
            const taskIndex = partner.partnerTask.findIndex(
              (t) => t.id === payload.id,
            );

            if (taskIndex !== -1) {
              partner.partnerTask[taskIndex] = payload;
            }
          }
        },
      );
  },
});

export const { counterPartnerTaskTimer } = tasksSlice.actions;
export default tasksSlice.reducer;
